/**
 * Shared types for the Proposal Deficiencies Step (task-03).
 *
 * ProposalDeficiencyApiRow  — raw shape from the task-02 JSON API.
 * ProposalDeficiencyViewModel — mapped, type-safe view-model used in every component.
 * DeficiencyFilters           — controlled filter state (wired to server params in task-06).
 * DeficiencyGroupBy           — discriminated union of the five group-by options.
 * DeficiencyListMode          — 'linked' | 'candidate' determines which columns/actions render.
 */
export const DEFAULT_DEFICIENCY_FILTERS = {
    dateOpenedFrom: null,
    dateOpenedTo: null,
    systemAssets: [],
    severity: null
};
export function isDefaultDeficiencyFilters(filters) {
    return (filters.dateOpenedFrom === null &&
        filters.dateOpenedTo === null &&
        filters.systemAssets.length === 0 &&
        filters.severity === null);
}
